/*
 FlagIcons


*/
import React, { Fragment } from 'react';
import { IconButton, Badge, Backdrop, Menu, MenuItem, Typography } from '@material-ui/core';

import { connect } from 'react-redux';
import {
  AppState, Actions, store,
  IPageState
} from '../../appredux'

import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import { PropTypes } from "@material-ui/core"
import CONFIG from '../../cfg/config'

import LanguageIcon from '@material-ui/icons/Language';
import Flag from 'react-flagkit';
/*
Deklaracje dla react-flagkit (declare.d.ts):
declare module 'react-flagkit';

Aby sprawdzał, trzeba by całą deklarację:

import { Component } from 'react';

interface FlagProps {
    country?: string;
}

declare class Flag extends Component<Props> { }

export default Flag;
*/
interface FlagProps {
  page: IPageState;
  flags: string[]
}

type FlagState = {
  anchorEl: any,
}

class FlagIconC extends React.Component<FlagProps & WithStyles<typeof styles>, FlagState> {

  constructor(props: any) {
    super(props, {});
    this.state = {
      anchorEl: null,
    }
  }

  openMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  findName = (name: string) => {
    const langNames = [
      { flag: 'pl', name: 'polski' },
      { flag: 'en', name: 'english' },
      { flag: 'de', name: 'deutsche' },
      { flag: 'sk', name: 'slovák' },
      { flag: 'cz', name: 'čeština' },
      { flag: 'ru', name: 'русский' },
      { flag: 'ua', name: 'українська' }
    ]

    let obj = langNames.find(x => x.flag === name)
    if (obj) {
      return obj.name
    } else {
      return ""
    }

  }

  //PM 2021-08-26
  //aktualizacja z zaktualizowana wersja react-flagkit
  render() {
    const { classes } = this.props;
    const openMenu = Boolean(this.state.anchorEl);
    //const lang = ['pl', 'en', ] //'de', 'sk', 'cz', 'ru', 'ua'];
    let lang = this.props.flags
    
    //const langNames = ['polski', 'english', 'deutsche', 'slovák', 'čeština', 'русский']

    let flgs: any[] = [];
    //CONFIG.
    lang.forEach((c) => {
      if (lang.includes(c)) {
        let bg = '';
        let clr: PropTypes.Color;
        let cc: string;
        if (c == 'en') cc = 'GB'
        //      else if (c=='pl') cc='PL'
        else cc = c.toUpperCase()
        if (this.props.page.lang == c) { bg = 'A'; clr = 'primary' }
        else { bg = ''; clr = 'default' }
        flgs.push(
          <IconButton
            onClick={() => {
              store.dispatch(Actions.pageState.setLang(c));
            }}
            color="inherit" key={c} style={{ padding: "8px 8px 4px 8px" }}
          >
            <Badge badgeContent={bg} color={clr}>
              <span>
                <Flag country={cc} size={20} />
              </span>
            </Badge>
          </IconButton>
        );
      }
    }
    );

    // if(CONFIG.lang.length >= 3){
    //   if (this.props.page.lang !== CONFIG.lang[0] && this.props.page.lang !== CONFIG.lang[1] && this.props.page.lang !== CONFIG.lang[2]) {
    //     let index = flgs.findIndex((flag: any) => flag.key == this.props.page.lang)
    //     let flgsCopy = Object.create(flgs)
    //     let actual = flgsCopy.splice(index, 1);

    //     flgsCopy.shift()
    //     flgsCopy.shift()
    //     flgs = [flgs[0], flgs[1], actual].concat(flgsCopy)
    //   }
    // }

    let flags: any[] = [];
    if (flgs.length <= 3) {
      flags = flgs
    } else {
      flags = flgs.slice(0, 3)
      flags.push(
        <IconButton onClick={this.openMenu} color="inherit" key={"..."} style={{ padding: "8px 8px 4px 8px", color: "#555" }}>
          <span
          //store.dispatch(Actions.pageState.setLang( c ));
          >
            <LanguageIcon style={{ fontSize: "1.2rem" }} color="primary" />
          </span>

        </IconButton>
      )
    }

    let menuFlags: any[] = [];
    CONFIG.lang.forEach((c, index) => {
      if (lang.includes(c)) {
        let bg = '';
        let clr: PropTypes.Color;
        let cc: string;
        if (c == 'en') cc = 'GB'
        else cc = c.toUpperCase()
        if (this.props.page.lang == c) { bg = 'A'; clr = 'primary' }
        else { bg = ''; clr = 'default' }
        menuFlags.push(
          <MenuItem key={index.toString()} className={classes.menuItem}
            onClick={() => {
              store.dispatch(Actions.pageState.setLang(c))
              this.closeMenu()
            }} >
            <IconButton color="inherit" key={c} style={{ padding: "8px 8px 4px 8px" }}>
              <Badge badgeContent={bg} color={clr}>
                <Flag country={cc} size={20} />
              </Badge>
            </IconButton>
            <Typography variant="h6" component="h2" className={classes.text}>
              {"- " + this.findName(c)}
            </Typography>
          </MenuItem>
        );
      }
    }
    );



    return (
      <Fragment>
        {/* // <div >
    //     {flgs}
    // </div> */}
        <div className={classes.outerPanel}>
        <div className={classes.itnl}>
          {flags}
        </div>
        </div>
        <Backdrop className={classes.backdrop} open={openMenu}>
          <Menu
            id="long-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            elevation={15}
            open={openMenu}
            onClose={this.closeMenu}
            PaperProps={{
              style: {
                //maxHeight: 10 * 4.5,
                width: '30ch',
                left: "200px",
                top: "200px"
                //paddingTop: "0"
              },
            }}

            MenuListProps={{
              style: {
                color: "#555",
                background: "linear-gradient(to bottom, #ffffff, #f7f7f7)"
              },
            }}
          >
            {menuFlags}
          </Menu>
        </Backdrop>
      </Fragment>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});


const styles = (theme: Theme) => ({
  outerPanel: {
    display: 'flex',
    justifyContent: 'center',
    margin: "-5px",
    height: "39px"
    //minWidth: "176px",
    //marginRight: "5px",
    //marginBottom: "5px"
  },
  itnl: {
    // marginLeft: "2em",
    // marginRight: '2em'
    padding: '2px 2px 2px 2px',
    display: 'inline',
    justifyContent: 'center',

    height: "34px",
    //border: "1px solid lavender",
  },
  flag: {
    width: "20px",
    height: "20px"
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  menuItem: {
    whiteSpace: "pre" as "pre",
    paddingBottom: "8px",
    paddingTop: "8px"
  },
  text: {
    paddingLeft: "15px",
    fontSize: "14px"
  }
});


export default connect(mapStateToProps)(withStyles(styles)(FlagIconC));

//export default FlagIcons

/*
old:
    let bgPL=''
    let plColor : PropTypes.Color = 'default'
    let enColor : PropTypes.Color = 'default'
    let bgEN=''
    if (this.props.page.lang=='pl') {bgPL='A';plColor='secondary'}
    else  {bgEN='A';enColor= 'secondary'}


        <IconButton color="inherit">
        <Badge badgeContent={bgEN} color={ enColor }>
        <span onClick={ ()=>{
          store.dispatch(Actions.pageState.setLang('en'));
        }}>
        <Flag country="GB" />
        </span>
        </Badge>
        </IconButton>
        <IconButton color="inherit">
        <Badge badgeContent={bgPL} color={ plColor }>
        <span onClick={ ()=>{
          store.dispatch(Actions.pageState.setLang('pl'));
          }}>
        <Flag country="PL" />
        </span>
        </Badge>
        </IconButton>
*/